<template>
  <div id="app" class="typo">
    <router-view />
    <Sender />
    <div class="footer">
      <div style="font-size:1rem;padding:10px 0;">
        <a href="http://ccpl.psych.ac.cn:20046/PsyMap/home/aid" target="__blank">寻求公益心理援助</a>
      </div>
      <div class="mailTo" style="font-size:1rem;padding:20px 0;">
        <span style="border:1px solid gray;padding:10px;" @click="mailTo">撰写悼文</span>
      </div>
      <div class="footerContent">
        <a id="miit" href="http://beian.miit.gov.cn">
          <p>粤ICP备16046833号-1</p>
        </a>

        <p class="simple">
          <span>悼文版权归原作所有</span>
        </p>
        <p class="simple">
          <span>Copyright © Garfield</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Sender from "@/components/Sender.vue";
export default {
  components: { Sender },
  data() {
    return {};
  },
  methods: {
    mailTo() {
      window.confirm(`发送悼文至 tanpok@outlook.com`);
    }
  }
};
</script>
<style lang="scss">
body,
html {
  font-family: Caslon;
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
}
a {
  color: rgba(24, 29, 49, 0.8);
  border-bottom: 1px dotted rgba(24, 29, 49, 0.8) !important;
}
#miit {
  border: 0 !important;
}
.footer {
  width: 100vw;
  margin: 0 auto;
  position: relative;
  bottom: 0;
  color: rgba(24, 29, 49, 0.8);
  font-size: 0.5rem;
  padding-bottom: 10vh;
  .toHomepage {
    font-size: 1rem;
    padding: 1vh 0;
  }
  &:before {
    content: "";
    display: block;
    width: 100vw;
    margin: 0 auto;
    border-bottom: 1px solid #dcdcdc;
  }
  .footerContent {
    padding: 1vh 0 5vh 0;
    width: 90%;
    margin: 0 auto;
    #miit {
      text-align: right;
      text-decoration: none;
      border-bottom: 0;
      letter-spacing: 1vw;
    }
    .simple {
      text-align: right;
      padding: 0;
      margin: 0;
    }
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
<style lang="scss" scoped>
.mailTo {
  span {
    cursor: pointer;
    transition: all 0.5s ease-in-out;
    &:hover {
      background: black;
      color: white;
    }
  }
}
</style>